import { render, staticRenderFns } from "./ChipsSelection.vue?vue&type=template&id=0573a05e&scoped=true"
import script from "./ChipsSelection.vue?vue&type=script&lang=js"
export * from "./ChipsSelection.vue?vue&type=script&lang=js"
import style0 from "./ChipsSelection.vue?vue&type=style&index=0&id=0573a05e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0573a05e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0573a05e')) {
      api.createRecord('0573a05e', component.options)
    } else {
      api.reload('0573a05e', component.options)
    }
    module.hot.accept("./ChipsSelection.vue?vue&type=template&id=0573a05e&scoped=true", function () {
      api.rerender('0573a05e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/vocational-evaluation/components/ChipsSelection.vue"
export default component.exports